import { ReactNode } from 'react';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants } from '@arrived/common';

import { useMediaQueryClasses } from '../../hooks';

export const StyledPropertyDetailsHighlight = styled.div`
  &.property-details-highlight {
    padding: ${({ theme }) => theme.spacing(2.5, 4)};
    background-color: ${({ theme }) => theme.palette.neutrals.milk};

    &.mobile {
      padding: ${({ theme }) => theme.spacing(2.5)};
    }
  }
`;

interface PropertyDetailsHighlightProps {
  className?: string;
  children: ReactNode;
}

export const PropertyDetailsHighlight = ({ className, children }: PropertyDetailsHighlightProps) => {
  return (
    <StyledPropertyDetailsHighlight className={clsx('property-details-highlight', className, useMediaQueryClasses())}>
      {children}
    </StyledPropertyDetailsHighlight>
  );
};
